import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgIf } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

//Services
import { ConsultarElegibilidadeService } from './consulta-elegibilidade.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

//Components
import { Beneficiario } from '../base/vo/beneficiario';
import { NovaGto } from '../base/vo/nova-gto';

@Component({
  selector: 'app-consulta-elegibilidade',
  templateUrl: './consulta-elegibilidade.component.html',
  styleUrls: ['./consulta-elegibilidade.component.css']
})
export class ConsultaElegibilidadeComponent implements OnInit {

  private resultadoBeneficiario = new Beneficiario();

  @Input() fluxoAlternativo: boolean = true;
  @Output() stepControl: EventEmitter<NovaGto> = new EventEmitter<NovaGto>();

  filtroCodigoBeneficiario: string = "";
  filtroCpfBeneficiario:    string = "";
  codBeneficiario:          string = "";
  cpfBeneficiario:          string = "";
  btnNovaGtoName:           string = "";

  beneficiarioSelected: Beneficiario;
  novaGto:              NovaGto;

  resultFound:    boolean;
  resultNotFound: boolean;
  buttonEnabled:  boolean = false;
  loading:        boolean = false;
  tipoClinica:    boolean = false; //FALSE: Prestador pessoa física; TRUE: Prestador pessoa juridica
  selecionaPrestadorExecutante: boolean = false; //Exibe a seleção de prestador executante no fluxo alternativo
  displayModalPrestExecutante:  boolean = false;

  constructor(private elegibilidadeService: ConsultarElegibilidadeService,
              private autenticacaoService: AutenticacaoService) { }

  ngOnInit() {    
    this.beneficiarioSelected = new Beneficiario(); 
    this.tipoClinica = this.autenticacaoService.isClinica;
    this.selecionaPrestadorExecutante = false;
    this.novaGto = new NovaGto();

    if(this.fluxoAlternativo){
      this.btnNovaGtoName = "Abrir Nova GTO";      
    }else{
      this.btnNovaGtoName = "Próximo";
    }
  }

  getElegibilidadeDescricao(elegivel: string): string {
    if (elegivel) {
      return "Elegível"
    } else {
      return "Não-Elegível"
    }
  }

  showBeneficiarioResult(result: boolean) {
    if (result) {
      this.resultFound = result;
      this.resultNotFound = false;      
    }
    else {
      this.resultFound = result;
      this.resultNotFound = true;      
    }
  }

  //Recupera os dados do associados e sua elegibilidade
  public consultarElegibilidade(): void {
    this.loading = true;
    this.buttonEnabled = false;
    this.elegibilidadeService.consultaElegibilidade(
      this.filtroCodigoBeneficiario, this.filtroCpfBeneficiario).subscribe(
        data => {         
          this.resultadoBeneficiario = data;         
          this.showBeneficiarioResult(true);
          this.loading = false;
          this.codBeneficiario = this.filtroCodigoBeneficiario;
          this.cpfBeneficiario = this.filtroCpfBeneficiario;
        },

        erro => {
          this.showBeneficiarioResult(false);
          this.loading = false;
          this.codBeneficiario = "";
          this.cpfBeneficiario = "";
        }
      );
  }

  private verificaTipoPrestador(){ 
    
    if(this.buttonEnabled){

      if(this.tipoClinica){
        //É pessoa juridica exibe modal de prestador executante
        this.displayModalPrestExecutante = true;
      }else{
        //É pessoa física e esta no fluxo normal, vai direto para a tela de plano de tratamento
        this.nextStep();        
      }
      
    }
    else{
      console.log("Associado não elegível.");
    }  
  }

  /**Metodo usado para controlar o passo a passo na tela de nova GTO pelo fluxo comum */
  nextStep() {
    if(this.tipoClinica){
      this.stepControl.emit(this.novaGto);
    }else{
      this.novaGto.codigoStep = 2;
      this.stepControl.emit(this.novaGto);
    }    
  }

  popularPrestador(gto){    
    this.novaGto = gto    
    this.nextStep();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/consulta-elegibilidade/consulta-elegibilidade.component.ts